import * as reactIntl from 'react-intl';
import * as yup from 'yup';

export const partnersFormValidation = (mainFormFields) => {
  const intl = reactIntl.useIntl();

  const requiredFieldMessage = intl.formatMessage({
    id: 'TRLT_UI-REQUIRED_FIELD',
  });

  const fieldMustBePercentage = intl.formatMessage({
    id: 'TRLT_UI-PERCENTAGE_FIELD',
  });

  const getFieldObligation = (fieldName) =>
    mainFormFields
      .find((mainFormField) => mainFormField.name === 'partners')
      .data[0].find((partnerField) => partnerField.name === fieldName)
      ?.isRequired;

  return yup.object().shape({
    partners: yup.array().of(
      yup.object().shape({
        partnerName: yup.string().when([], {
          is: () => getFieldObligation('partnerName'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        partnerNif: yup.string().when([], {
          is: () => getFieldObligation('partnerNif'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        capitalPctg: yup.string().when([], {
          is: () => getFieldObligation('capitalPctg'),
          then: () =>
            yup
              .string()
              .matches(/^(100|(\d{1,2}(\.\d{1,2})?))$/, fieldMustBePercentage)
              .required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
      }),
    ),
  });
};
